import { tokenInstance } from 'lib/axios/instance';

export const createMatch = async (avatarId, managerId) => {
  if (!(avatarId && managerId)) return;
  await tokenInstance.put('/api/v1/team-managers/match', {
    avatarId,
    managerId,
  });
};
